import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { pageInMemoryList } from '../api/localPagedList';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/mex/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetMesasListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listMesas(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupMesas(query = { page: 1, pageSize: 5 }) {
  return listMesas(query);
}

export function getMesa(id) {
  return requestAndUnwrap(apiClient.get(`/api/mex/${id}`));
}

export function deleteMesa(id) {
  return requestAndUnwrap(apiClient.get(`/api/mex/delete/${id}`));
}

export function saveMesa(payload) {
  return requestAndUnwrap(apiClient.post('/api/mex', payload));
}

export function listMesasActivas(carreraId) {
  return requestAndUnwrap(apiClient.get(`/api/mex/activas/${carreraId}`));
}

export async function listMesasActivasPaged(carreraId, query = { page: 1, pageSize: 5 }) {
  const items = await listMesasActivas(carreraId);
  return pageInMemoryList(items, query);
}

export function uploadMesasBulk(payload) {
  return requestAndUnwrap(apiClient.post('/api/mex/archivo', payload));
}

export function generarActaExamen(mesaCod) {
  return requestAndUnwrap(apiClient.get(`/api/aex/generate/${mesaCod}`));
}
